import { useMemo, useRef, useState } from "react";

import styles from "../../../styles/service/products.module.scss";

import slugify from "slugify";
import * as ItemDisplayable from "@olga-food/schemas/lib/classes/schemas/catalog/ItemDisplayable";
import { CatalogHelpers } from "shared/tools/CatalogHelpers";
import { If } from "shared/components/control-statements";
import { InputSearch } from "shared/components/InputSearch";

const CategoryItem = ({ category, onSelectCategory }) => {
  const ref = useRef(null);

  return (
    category.items.length > 0 && (
      <div
        className={styles.category}
        ref={ref}
        id={`categoria-${slugify(category.name.toLowerCase())}`}
        onClick={() => onSelectCategory(category)}
      >
        <p className={styles.name}>{category.name}</p>
      </div>
    )
  );
};

export default function Categories({
  categories,
  onSelectCategory,
  onSelectProduct,
  initialCategory,
}) {
  const [selectedCategory, setSelectedCategory] = useState(
    initialCategory || null,
  );

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    onSelectCategory(category);
  };

  const handleSelectProduct = (product, category) => {
    onSelectProduct(product, category);
  };

  const [searchProduct, setSearchProduct] = useState("");
  const [searchCategory, setSearchCategory] = useState("");

  const handleSearchProduct = (e) => {
    setSearchProduct(e.target.value);
  };

  const handleSearchCategory = (e) => {
    setSearchCategory(e.target.value);
  };

  const filteredProducts = useMemo(() => {
    if (!searchProduct) return selectedCategory?.items || [];
    return (selectedCategory?.items || []).filter((item) =>
      item.name.toLowerCase().includes(searchProduct.toLowerCase()),
    );
  }, [selectedCategory, searchProduct]);

  const filteredCategories = useMemo(() => {
    if (!searchCategory) return categories;
    return categories.filter((category) =>
      category.name.toLowerCase().includes(searchCategory.toLowerCase()),
    );
  }, [categories, searchCategory]);

  return (
    <>
      <If cond={!selectedCategory}>
        <div className="d-flex align-center justify-between mb-20">
          <p className={styles.title}>Selecione uma categoria</p>
          <InputSearch
            design="two"
            placeholder="Buscar por..."
            value={searchCategory}
            onChange={handleSearchCategory}
          />
        </div>
        <div className={styles.categories}>
          {filteredCategories.map((category, index) => {
            const someProductIsVisible = category.items.some((i) => i.visible);

            if (!category.available && !someProductIsVisible) return null;

            return (
              <CategoryItem
                key={index}
                category={category}
                onSelectCategory={() => handleSelectCategory(category)}
              />
            );
          })}
        </div>
      </If>

      <If cond={!!selectedCategory}>
        <div className="d-flex align-center justify-between mb-20">
          <p className={styles.title}>Selecione um produto</p>
          <InputSearch
            design="two"
            placeholder="Buscar por..."
            value={searchProduct}
            onChange={handleSearchProduct}
          />
        </div>
        <div className={styles.products}>
          {(filteredProducts || []).map((item, _i) => {
            const oldPrice = CatalogHelpers.mountOldPrice(item);
            const hasAddons = (item.items || []).length > 0;
            const hasSizes = (item.sizes || []).length > 1;

            const shouldShow = ItemDisplayable.isItemDisplayable(item);

            return (
              item.show &&
              item?.showAll !== false &&
              shouldShow &&
              item.available &&
              item.visible && (
                <div
                  key={_i}
                  className={styles.product}
                  onClick={() => handleSelectProduct(item, selectedCategory)}
                >
                  <p className={styles.name}>{item.name}</p>
                  {CatalogHelpers.isPromotionalPrice(item) &&
                  oldPrice &&
                  !(hasAddons || hasSizes) ? (
                    <p className={styles.fromPrice}>
                      <strike>{oldPrice}</strike>&nbsp;&nbsp;
                      <span className={styles.price}>
                        {CatalogHelpers.mountPrice(item)}
                      </span>
                    </p>
                  ) : CatalogHelpers.isPromotionalPrice(item) && !hasSizes ? (
                    <p className={styles.fromPrice}>
                      A partir de&nbsp;
                      <span className={styles.price}>
                        {CatalogHelpers.mountPrice(item)}
                      </span>
                      {/* &nbsp;&nbsp;
                      <strike>{oldPrice}</strike> */}
                    </p>
                  ) : hasAddons || hasSizes ? (
                    <p className={styles.fromPrice}>
                      A partir de&nbsp;
                      <span className={styles.price}>
                        {CatalogHelpers.mountPrice(item)}
                      </span>
                      {/* <If cond={catalogDiscount}>
                          &nbsp;&nbsp;
                          <strike>{oldPrice}</strike>
                        </If> */}
                    </p>
                  ) : (
                    <p className={styles.fromPrice}>
                      <span className={styles.price}>
                        {CatalogHelpers.mountPrice(item)}
                      </span>
                      {/* <If cond={catalogDiscount}>
                          &nbsp;&nbsp;
                          <strike>{oldPrice}</strike>
                        </If> */}
                    </p>
                  )}
                </div>
              )
            );
          })}
        </div>
      </If>
    </>
  );
}
